module.exports = __webpack_public_path__ + "media/images/home/steps/already_planing-56b0ed5f1a83478f28ee3b4a36b2d05e.png";